import React, { useCallback } from 'react'
import { useInstData } from 'tyan/public/hooks'

const FilesEditor = props => {
	const { initValuesBasic, showBody: Body, onConfirm, onClose, name, title, filesProps = {} } = props
	const { me, me: { state: {
		changedValuesBasic, typesOfchangedValuesBasic
	} } } = useInstData(props, useCallback(() => ({
		state: {
			changedValuesBasic: {}
		}
	}), []))

	const canSave = () => changedValuesBasic && Object.keys(changedValuesBasic).length > 0
	const handleSave = () => (onConfirm && onConfirm(changedValuesBasic, typesOfchangedValuesBasic), onClose && onClose())
	const handleClose = () => onClose && (canSave() ? Tyan.pubForm.showConfirm('确定要放弃更改吗?', onClose) : onClose())
	const fieldsetBasic = useCallback(() => [
		{ _files: title, name, ...filesProps },
	], [name])

	return !initValuesBasic ? (onClose && setTimeout(onClose, 1), null) : <Body data={me} maxWidth={'1100px'}
		controls={[
			{ _button: '保存', handler: handleSave, disabled: !canSave() },
			// { _button: 'DELETE', handler: handleDelete, cdt: () => initValuesBasic.id },
			{ _button: canSave() ? '取消' : '关闭', handler: handleClose },
		]}
		fieldsets={[
			{ title: '', name: 'Basic', _fieldset: fieldsetBasic(), /* docked: 'top'  */ },
			// { title: 'Classes', name: 'Basic', _fieldset: fieldsetList(), fullblock: true },
		]}
	/>
}

export default FilesEditor